"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockKit = void 0;
const __1 = require("../");
const kit_intent_1 = require("./kit_intent");
function mockKit(overrides = {}) {
    return {
        description: 'Mock description',
        id_hash: 'mock_id_hash',
        id: 1,
        kit_intents: [(0, kit_intent_1.mockKitIntent)()],
        slug: 'mock_slug',
        title: 'Mock title',
        user: (0, __1.mockAmbassadorMini)(),
        ...overrides,
    };
}
exports.mockKit = mockKit;
